import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";
import Modal from "@mui/material/Modal";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { getErrorToast, getSuccessToast } from "../../../toast";
import video_btn from "../../../assets/video.svg";
import video_active from "../../../assets/video_active.svg";
import details from "../../../assets/stock_details.svg";
import details_active from "../../../assets/details_active.svg";
import exit from "../../../assets/exit_box.svg";
import logo from "../../../assets/logo.svg";
import "./Header.css";

import StockistDetails from "./StockistDetails";
import VideoContext from "../../../context/VideoContext";

const Header = () => {
  const [showDetails, setShowDetails] = useState(false);
  const { videoFeed, setVideoFeed } = useContext(VideoContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [partyInfo, setPartyInfo] = useState([]);

  useEffect(() => {
    if (boxId) {
      axiosPrivate
        .get(`/data_entry/party-info/${ReactSession.get("box_id")}/`)
        .then((res) => {
          setPartyInfo(res.data);
        });
    }

    return () => {
      setPartyInfo([]);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const donotExitBox = () => {
    setOpen(false);

    ReactSession.remove("box_id");

    navigate("/operator");
  };

  const confirmExitBox = () => {
    const boxId = ReactSession.get("box_id");

    const data = {
      stockists_master_id: boxId,
      mark_box: "True",
    };

    axiosPrivate
      .patch("/dashboard/mark_box/", data)
      .then((res) => {
        if (res.status === 200) {
          ReactSession.remove("box_id");
          getSuccessToast("Box completed successfully", 1000);
          setTimeout(() => {
            navigate("/operator");
          }, 2000);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setOpen(false);
  };

  const toggleCamera = () => {
    setVideoFeed(!videoFeed);
  };

  const displayDetails = (e) => {
    setShowDetails(true);
  };

  const hideDetaiils = (e) => {
    setShowDetails(false);
  };

  const boxId = ReactSession.get("box_id");


  return (
    <div className="header-container">
      <Modal open={open} onClose={handleClose}>
        <div className="delete-modal">
          <div className="delete-modal-desc">
            <img alt="bin" className="delete-modal-img" src={exit} />
            <p className="delete-modal-desc-para dmdp-1">
              Is this claim completed?
            </p>
          </div>
          <div className="delete-modal-btns">
            <button
              onClick={donotExitBox}
              className="delete-modal-btn dmb-1"
              id="yes"
            >
              No
            </button>
            <button
              onClick={confirmExitBox}
              className="{/*delete-modal-btn*/} box-complete-btn"
              id="no"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
      <section className="header-container-logo-section">
        <img className="header-container-logo-image" src={logo} alt="sasad" />
      </section>
      {boxId ? (
        <section className="header-container-button-section">
          <button
            onClick={toggleCamera}
            className={`header-container-button ${
              videoFeed
                ? "header-container-camera-button-active"
                : "header-container-camera-button"
            }`}
          >
            <img
              className="header-container-button-images header-container-camera-button-image"
              src={videoFeed ? video_active : video_btn}
              alt="dsa"
            />
          </button>
          <button
            onMouseEnter={displayDetails}
            onMouseLeave={hideDetaiils}
            className="header-container-button"
          >
            <img
              className="header-container-button-images"
              src={showDetails ? details_active : details}
              alt="dsa"
            />
          </button>
          <button
            onClick={() => {
              setOpen(true);
            }}
            className="header-container-button"
          >
            <img
              className="header-container-button-images"
              src={exit}
              alt="dsa"
            />
            {/*<p>Exit Box</p>*/}
          </button>
          {showDetails && <StockistDetails partyInfo={partyInfo} />}
        </section>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Header;
